(function ($) {
	/**
	 * initializeBlock
	 *
	 * Adds custom JavaScript to the faqs-block HTML.
	 *
	 * @date    04/05/2024
	 * @since   4.0.0
	 *
	 * @return  void
	 */
	const initializeBlock = function ($block) {
		// Initially set the first item as active and show its content
		const $firstItem = $block.find('.item').first();
		// $firstItem.addClass('active');
		$firstItem.find('.content').hide(); // Open the first item
		$firstItem.find('.arrow-down').removeClass('hidden');
		$firstItem.find('.arrow-up').addClass('hidden');

		$block.on('click', '.icon', function () {
			const $item = $(this).closest('.item');
			const $content = $item.find('.content');
			const $arrowUp = $item.find('.arrow-up');
			const $arrowDown = $item.find('.arrow-down');
			const isActive = $item.hasClass('active');

			// Close all items
			$block.find('.item').removeClass('active');
			$block.find('.content').slideUp(400);
			$block.find('.arrow-up').addClass('hidden');
			$block.find('.arrow-down').removeClass('hidden');

			// Open the clicked item if it wasn't already open
			if (!isActive) {
				$item.addClass('active');
				$content.slideDown(400);
				$arrowDown.addClass('hidden');
				$arrowUp.removeClass('hidden');
			}
		});
	};

	// Initialize each block on a page load (front end).
	$(document).ready(function () {
		$('.wp-block-acf-faqs-block').each(function () {
			initializeBlock($(this));
		});
	});

	// Initialize dynamic block preview (editor).
	if (window.acf) {
		window.acf.addAction(
			'render_block_preview/type=faqs-block',
			function ($block) {
				initializeBlock($($block));
			}
		);
	}
})(jQuery);
